import './layout.scss';
import Vue from 'vue';
import macc from '../../modules/MACC/macc';
import meda from '../../modules/MEDA/meda';
/* components for inherintance */
import mevp from '../../modules/MEVP/mevp';
/* components for inherintance */
import mvtu from '../../modules/MVTU/mvtu';
import layoutBase from '../layout-base';
import videoPlayer from '../../common/components/video-player/video-player.vue';

Vue.component('macc', macc);
Vue.component('mevp', mevp);
Vue.component('meda', meda);
Vue.component('mvtu', mvtu);
Vue.component('video-player', videoPlayer);
/* eslint-disable no-new*/
new Vue({
	el: '[data-layout-id=PPELO-app]',
	extends: layoutBase
});
/* eslint-enable*/
